/**
 * 等待时间结束
 * @param ms 等待毫秒数
 */
export default function delay(ms: number): Promise<void> {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    })
}
